import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { trackEvent } from 'helpers/analytics';
import NoAccess from '../NoAccess';
import { SignUp } from './steps/signUp';
import { useOnboarding } from './hooks/useOnboarding';
import { NetworkOnboardingLayout } from './components/networkOnboardingLayout';
import usePageHook from '../../hooks/usePageHook';

import Walkthrough from './walkthrough';

export const Onboarding = () => {
  const { activeNetwork, path } = useOnboarding();
  usePageHook('Onboarding');

  useEffect(() => {
    if (activeNetwork?.id) {
      trackEvent('admin_onboarding:start', { networkId: activeNetwork.id });
    }
  }, [activeNetwork?.id]);

  if (!activeNetwork) {
    return <Redirect to="/not-found" />;
  }

  if (!activeNetwork.isManager && !activeNetwork.isOrganizationManager) {
    return <NoAccess />;
  }

  return (
    <NetworkOnboardingLayout>
      <Route path={path} exact>
        <SignUp />
      </Route>
      <Switch>
        <Route path={`${path}/onboarding/:step`}>
          <Walkthrough />
        </Route>
        <Route path={`${path}/onboarding`}>
          <Redirect to={path} />
        </Route>
      </Switch>
    </NetworkOnboardingLayout>
  );
};
